module.exports = __webpack_public_path__ + "img/x.4f30ab8e.svg";